<footer>
  <div class="footer-content left-content">
    <div *ngIf="iS.getWhiteLabel && iS.getWhiteLabel?.type === 'basic'">Powered By:</div>
    <ng-container *ngIf="iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance';else normalLogo">
      <img [src]="'/assets/images/' + iS.getWhiteLabel.logo" class="logo" alt="" [style]="{height:'64px'}">
    </ng-container>
    <ng-template #normalLogo>
      <img [src]="isIiccs ? '/assets/images/iiccsforum2025.webp':'/assets/images/logo.png'" class="logo" alt="">
    </ng-template>
    <ng-container *ngIf="isIiccs;else normalFooter">
      <div class="link-container">
        <a class="link" [attr.href]="!iS.isSukha ? 'mailto:info@addtix.id' : null">
          <img src="/assets/images/icons/mail.svg" alt="mail" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Email' | translate }}</p>
            <p>info@addtix.id</p>
          </div>
        </a>
      </div>
      <div class="link-container mt-3">
        <a class="link" href="https://www.google.co.uk/maps/place/Plaza+Asia,+Senayan,+Kec.+Kby.+Baru,+Kota+Jakarta+Selatan,+Daerah+Khusus+Ibukota+Jakarta/@-6.2254512,106.8045194,19z/data=!3m1!4b1!4m6!3m5!1s0x2e69f14e34f35ea9:0xcf7662c9e32e5ac7!8m2!3d-6.2254512!4d106.8051631!16s%2Fg%2F11bw4j7h8r?entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D" target="_blank" >
          <img src="/assets/images/icons/address.svg" alt="address" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Address' | translate }}</p>
            <p>Plaza Asia, 18th Floor,
              Jl. Jend. Sudirman Kav 59, Jakarta Selatan 12190, Indonesia</p>
          </div>
        </a>
      </div>
    </ng-container>
    <ng-template #normalFooter>
      <div class="link-container">
        <a class="link" [attr.href]="!iS.isSukha ? (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? 'mailto:'+iS.getWhiteLabel?.email : 'mailto:info@addtix.my') : null">
          <img src="/assets/images/icons/mail.svg" alt="mail" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Email' | translate }}</p>
            <p>{{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.email : 'info@addtix.my') }}</p>
          </div>
        </a>
      </div>
      <div class="link-container mt-3">
        <a class="link" >
          <img src="/assets/images/icons/address.svg" alt="address" loading="lazy">
          <div class="text-container">
            <p class="label">{{ 'Address' | translate }}</p>
            <p>{{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.address : 'Lot 1036-20, Jln Hj Shariff Off Jln Sakun, Bestari Jaya, Selangor.') }}</p>
          </div>
        </a>
      </div>
    </ng-template>
  </div>
  <ng-container *ngIf="false">
    <div class="footer-content center-content" *ngIf="!iS.isSukha && !iS.isOnePiece && !iS.isAK && !iS.isRichieRen && !iS.isHillsong">
      <h3>{{ 'Company' | translate }}</h3>
      <a [routerLink]="['/about-us']">{{ 'About Us' | translate }}</a>
    </div>
    <div class="footer-content center-content" *ngIf="!iS.isSukha && !iS.isOnePiece && !iS.isAK && !iS.isRichieRen && !iS.isHillsong">
      <h3>{{ 'Customer Care' | translate }}</h3>
<!--      <a [routerLink]="['/faq']">{{ 'FAQs' | translate }}</a>-->
       <a [routerLink]="['/privacy-policy']">{{ 'Privacy & Policy' | translate }}</a>
       <a [routerLink]="['/terms-condition']">{{ 'Terms & Conditions' | translate }}</a>
    </div>
  </ng-container>

  <div class="footer-content center-content" [class.w-100]="iS.isSukha" *ngIf="iS.isSukha">
    <h3>{{ 'Customer Care' | translate }}</h3>
    <div class="w-75 fs-6 d-inline-block" [class.w-100]="iS.isSukha">
      <span>Produk atau jasa ini disediakan dan menjadi tanggung jawab ADDTix. Untuk
        layanan contact center ADDTix hubungi +62821-2599-9908 atau info@addtix.id. Cek Syarat dan Ketentuan layanan lengkap </span>
      <a href="https://bmri.id/sukhatncxaddtix" class="fs-6 d-inline-block">di sini</a>
    </div>
    <!-- <a [routerLink]="['/privacy-policy']">{{ 'Privacy & Policy' | translate }}</a> -->
    <!-- <a [routerLink]="['/terms-condition']">{{ 'Terms of Use' | translate }}</a> -->
  </div>
  <div class="footer-content right-content" *ngIf="!iS.isSukha">
    <h3>{{ 'Payment by' | translate }}</h3>
    <div class="brand-container">
      <ng-container *ngIf="!iS.isSukha; else brandSukha">
        <img src="/assets/images/icons/senang-pay.png" alt="logo" loading="lazy" [style]="{height: '32px'}">
      </ng-container>
      <ng-template #brandSukha>
        <img src="/assets/images/icons/mandiri.png" alt="logo" loading="lazy">
      </ng-template>
    </div>
  </div>
  <div class="copyright" *ngIf="!isIiccs">
    ©️ {{ yearNow }}. {{ (iS.getWhiteLabel && iS.getWhiteLabel?.type === 'advance' ? iS.getWhiteLabel?.promoter : 'Addtix MY' )}}
  </div>
</footer>
